/**
 * SecuritySection — Task #9 B3-FE
 *
 * Zeigt die aktuelle Sitzung (Design-Referenz settings.html: "Sessions" —
 * ein "Active"-Eintrag fuer die laufende Sitzung; weitere Geraete/Remote-
 * Abmeldung sind eine Folge-Story, siehe BE-Hinweis unten) sowie 2FA und
 * Active-Sessions-Verwaltung als "Demnächst"-Sektionen, da deren BE-Endpoints
 * noch nicht existieren.
 *
 * BE-Folge-Stories:
 * - 2FA: BE-Endpoint für TOTP/Authenticator-App-Setup benötigt
 * - Active-Sessions (weitere Geraete): BE-Endpoint GET /api/v2/account/sessions + DELETE benötigt
 *
 * Passwort-Änderung ist bereits verdrahtet (PasswordChangeForm).
 */
import { useTranslation } from 'react-i18next'

export function SecuritySection({ onLogout }: { onLogout?: () => void } = {}) {
  const { t } = useTranslation('settings')

  return (
    <div className="card card-pad" style={{ marginBottom: 18 }} data-testid="security-section">
      <h3 style={{ marginBottom: 14 }}>{t('security.title')}</h3>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {onLogout && (
          <div className="spread" data-testid="current-session-row">
            <div>
              <div style={{ fontWeight: 500, fontSize: 13 }}>{t('session.title')}</div>
              <div className="muted" style={{ fontSize: 12 }}>{t('session.logoutHint')}</div>
            </div>
            <button type="button" onClick={onLogout} className="btn btn-sm">
              {t('session.logout')}
            </button>
          </div>
        )}

        {/* 2FA — demnächst */}
        <div
          className="spread"
          data-testid="2fa-section"
          data-coming-soon="true"
          style={{ opacity: 0.6 }}
        >
          <div>
            <div style={{ fontWeight: 500, fontSize: 13 }}>{t('security.twoFa.title')}</div>
            <div className="muted" style={{ fontSize: 12 }}>
              {t('security.twoFa.hint')}
            </div>
          </div>
          <span className="pill" style={{ fontSize: 11 }}>
            {t('security.comingSoon')}
          </span>
        </div>

        {/* Active Sessions — demnächst */}
        <div
          className="spread"
          data-testid="active-sessions-section"
          data-coming-soon="true"
          style={{ opacity: 0.6 }}
        >
          <div>
            <div style={{ fontWeight: 500, fontSize: 13 }}>{t('security.sessions.title')}</div>
            <div className="muted" style={{ fontSize: 12 }}>
              {t('security.sessions.hint')}
            </div>
          </div>
          <span className="pill" style={{ fontSize: 11 }}>
            {t('security.comingSoon')}
          </span>
        </div>
      </div>
    </div>
  )
}
